<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [title]="'Audit Log'"
      [class]="extraClass"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper class="full-page" [style.marginTop]="!windowService.isDesktopRes ? '60px' : '0px'">

    @if (windowService?.isDesktopRes) {
      <tidy-desktop-header>
        <div class="wrappable-container">
          <tidy-image
            [src]="'assets/svg/arrow-back-black.svg'"
            (action)="goBack()"
            class="desktop-back-icon clickable" />
          <tidy-text
            [title]="'Audit Log'" />
        </div>
      </tidy-desktop-header>
    }

    <!-- Loading State -->
    @if (!loaded) {
      <tidy-card>
        <tidy-row class="vertical-align-middle extra-bottom-padding">
          <ion-skeleton-text animated style="width: 24px; height: 24px; border-radius: 4px;" />
          <ion-skeleton-text animated style="width: 80px; height: 20px; margin-left: 8px;" />
          <ion-skeleton-text animated style="width: 35px; height: 35px; border-radius: 4px; margin-left: auto;" />
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <ion-skeleton-text animated style="width: 150px; height: 16px;" />
        </tidy-row>
        <tidy-divider />
        <tidy-row class="extra-top-padding">
          <ion-skeleton-text animated style="width: 100%; height: 200px; border-radius: 8px;" />
        </tidy-row>
      </tidy-card>
    }

    @if (loaded && guestReservationSyncRun) {
      <!-- Summary Card -->
      <tidy-card>
        <tidy-row class="vertical-align-middle extra-bottom-padding">
          <div
            class="status-badge"
            [class.status-success]="guestReservationSyncRun?.status !== 'failure'"
            [class.status-failure]="guestReservationSyncRun?.status === 'failure'">
            <tidy-image
              [src]="guestReservationSyncRun?.status === 'failure' ? 'assets/img/block.svg' : 'assets/img/checkmark.svg'"
              class="status-icon" />
            <span class="status-text">{{ guestReservationSyncRun?.status | titlecase }}</span>
          </div>
        </tidy-row>
        <tidy-row class="vertical-align-middle extra-bottom-padding">
          <tidy-image
            [src]="guestReservationSyncRun?.guest_reservation_source_type?.logo_url"
            style="width: 35px; height: 35px; object-fit: contain;" />
          <div style="margin-left: 12px;">
            <tidy-text [header]="guestReservationSyncRun?.guest_reservation_source_type?.name" />
            <div class="timestamp-container">
              <tidy-text
                [helper]="(guestReservationSyncRun?.created_at | parseDateTime:'MMM d, yyyy':'local') + (' at ' | translate) + (guestReservationSyncRun?.created_at | parseDateTime:'h:mma':'local')" />
              <span class="time-ago">({{ guestReservationSyncRun?.created_at | timeAgo }})</span>
            </div>
          </div>
        </tidy-row>
        @if (guestReservationAddresses && guestReservationAddresses !== '') {
          <tidy-row>
            <div>
              <tidy-text [helper]="'Addresses'" />
              <tidy-text [body]="guestReservationAddresses" style="margin-left: 5px;" />
            </div>
          </tidy-row>
        }
      </tidy-card>

      <!-- Sync Data Card -->
      <tidy-card>
        <div class="json-card-header">
          <div class="json-header-left" (click)="toggleCollapse('sync')">
            <tidy-image
              [src]="syncDataCollapsed ? 'assets/svg/chevron-forward-outline.svg' : 'assets/svg/chevron-down-outline.svg'"
              class="collapse-icon clickable" />
            <tidy-text [header]="'Sync Data'" />
            <span class="line-count">({{ syncDataLineCount }} lines)</span>
          </div>
          <div class="json-header-actions">
            <tidy-image
              [src]="'assets/svg/search-outline.svg'"
              class="action-icon clickable"
              [class.action-icon-active]="syncDataSearchVisible"
              (action)="toggleSearch('sync')" />
            <tidy-image
              [src]="'assets/svg/copy-outline.svg'"
              class="action-icon clickable"
              (action)="copyToClipboard('sync')" />
            <tidy-image
              [src]="'assets/svg/download-outline.svg'"
              class="action-icon clickable"
              (action)="downloadJson('sync')" />
            <tidy-image
              [src]="'assets/svg/expand-outline.svg'"
              class="action-icon clickable"
              (action)="toggleFullScreen('sync')" />
          </div>
        </div>
        @if (syncDataSearchVisible) {
          <tidy-row class="search-row">
            <input
              type="text"
              class="json-search-input"
              placeholder="Search in JSON..."
              [value]="syncDataSearch"
              (input)="onSearchInput($event, 'sync')" />
          </tidy-row>
        }
        @if (!syncDataCollapsed) {
          <tidy-row class="json-container">
            <pre class="json-code-block" [innerHTML]="formattedSyncData"></pre>
          </tidy-row>
        }
      </tidy-card>

      <!-- Sync Data Fullscreen Overlay -->
      @if (syncDataFullScreen) {
        <div class="json-fullscreen-overlay">
          <div class="json-fullscreen-header">
            <tidy-text [header]="'Sync Data'" />
            <div class="json-fullscreen-actions">
              <tidy-image
                [src]="'assets/svg/copy-outline.svg'"
                class="action-icon clickable"
                (action)="copyToClipboard('sync')" />
              <tidy-image
                [src]="'assets/svg/download-outline.svg'"
                class="action-icon clickable"
                (action)="downloadJson('sync')" />
              <tidy-image
                [src]="'assets/svg/close-outline.svg'"
                class="action-icon clickable close-icon"
                (action)="toggleFullScreen('sync')" />
            </div>
          </div>
          <div class="json-fullscreen-search">
            <input
              type="text"
              class="json-search-input"
              placeholder="Search in JSON..."
              [value]="syncDataSearch"
              (input)="onSearchInput($event, 'sync')" />
          </div>
          <div class="json-fullscreen-content">
            <pre class="json-code-block" [innerHTML]="formattedSyncData"></pre>
          </div>
        </div>
      }

      <!-- Failure Data Card (only show if there's failure data) -->
      @if (hasFailureDataFlag) {
        <tidy-card>
          <div class="json-card-header">
            <div class="json-header-left" (click)="toggleCollapse('failure')">
              <tidy-image
                [src]="failureDataCollapsed ? 'assets/svg/chevron-forward-outline.svg' : 'assets/svg/chevron-down-outline.svg'"
                class="collapse-icon clickable" />
              <tidy-text [header]="'Failure Data'" />
              <span class="line-count">({{ failureDataLineCount }} lines)</span>
            </div>
            <div class="json-header-actions">
              <tidy-image
                [src]="'assets/svg/search-outline.svg'"
                class="action-icon clickable"
                [class.action-icon-active]="failureDataSearchVisible"
                (action)="toggleSearch('failure')" />
              <tidy-image
                [src]="'assets/svg/copy-outline.svg'"
                class="action-icon clickable"
                (action)="copyToClipboard('failure')" />
              <tidy-image
                [src]="'assets/svg/download-outline.svg'"
                class="action-icon clickable"
                (action)="downloadJson('failure')" />
              <tidy-image
                [src]="'assets/svg/expand-outline.svg'"
                class="action-icon clickable"
                (action)="toggleFullScreen('failure')" />
            </div>
          </div>
          @if (failureDataSearchVisible) {
            <tidy-row class="search-row">
              <input
                type="text"
                class="json-search-input"
                placeholder="Search in JSON..."
                [value]="failureDataSearch"
                (input)="onSearchInput($event, 'failure')" />
            </tidy-row>
          }
          @if (!failureDataCollapsed) {
            <tidy-row class="json-container">
              <pre class="json-code-block" [innerHTML]="formattedFailureInfo"></pre>
            </tidy-row>
          }
        </tidy-card>

        <!-- Failure Data Fullscreen Overlay -->
        @if (failureDataFullScreen) {
          <div class="json-fullscreen-overlay">
            <div class="json-fullscreen-header">
              <tidy-text [header]="'Failure Data'" />
              <div class="json-fullscreen-actions">
                <tidy-image
                  [src]="'assets/svg/copy-outline.svg'"
                  class="action-icon clickable"
                  (action)="copyToClipboard('failure')" />
                <tidy-image
                  [src]="'assets/svg/download-outline.svg'"
                  class="action-icon clickable"
                  (action)="downloadJson('failure')" />
                <tidy-image
                  [src]="'assets/svg/close-outline.svg'"
                  class="action-icon clickable close-icon"
                  (action)="toggleFullScreen('failure')" />
              </div>
            </div>
            <div class="json-fullscreen-search">
              <input
                type="text"
                class="json-search-input"
                placeholder="Search in JSON..."
                [value]="failureDataSearch"
                (input)="onSearchInput($event, 'failure')" />
            </div>
            <div class="json-fullscreen-content">
              <pre class="json-code-block" [innerHTML]="formattedFailureInfo"></pre>
            </div>
          </div>
        }
      }
    }
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [isfullWidthContent]="true" [templateContent]="content" />
